import {getPerson} from './getPerson'
import {getNames} from './getNames'

export const persons = {
  getPerson,
  getNames,
}
